import React, { FC, useState } from 'react'
import { ModalProduct } from './ModalProduct'
import { Product } from './ProductsCard'
import { MdOpenInNew } from "react-icons/md";

export const CardProduct: FC<Product> = (props) => {
  const {isModal, photo, title, desc, modalPhotos, modalDescription, modalPhotosHeight, isDocument, document} = props
  const [isModalActive, setIsModalActive] = useState(false)

  const btnAction = () => {
    if (isModal) {
      setIsModalActive(isModal)
    } else if (isDocument) {
      openDocument(document)
    }
  } 

  const openDocument = (documentName) => {
    window.open('/documents/' + documentName, '_blank');
  }

  return (
    <div className={`product ${(isModal || isDocument) && 'cursor-pointer'}`} onClick={btnAction}>
      <img src={photo} alt={photo} />

      <div className='text-block'>
        <span className='title'>{title}</span>

        <p className='desc'>{desc} {isDocument && <MdOpenInNew className='mx-[5px] text-[25px]'/>}</p>
      </div>

      {isModal && (
        <ModalProduct 
          title={title}
          modalPhotos={modalPhotos}
          modalDescription={modalDescription}
          isModal={isModalActive}
          setIsModal={setIsModalActive}
          modalPhotosHeight={modalPhotosHeight}
        />
      )}
    </div>
  )
}
